// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lncoming {\n  font-size: 15px;\n}\n.lncoming .el-date-editor .el-range-separator {\n    width: 7%;\n}\n.lncoming .lncoming-row {\n    margin: 40px 0px 40px 0px;\n}\n.lncoming .lncoming-table {\n    margin-bottom: 20px;\n}\n.lncoming .lncoming-table .cell {\n      text-align: center;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
